module.exports = __webpack_public_path__ + "img/news-default.15886d3c.svg";